import { type PropsWithChildren } from 'react';

import type { DateThresholdConfig } from '../../core/types/thresholds.js';

/**
 * Props for the TimeseriesChart.Threshold slot component
 * @public
 */
export type TimeseriesChartThresholdProps = DateThresholdConfig;

/**
 * @public
 */
export const Threshold = (
  props: PropsWithChildren<TimeseriesChartThresholdProps>,
) => null;
